import * as tokens from '@hover/tokens-border';
import * as tokens$1 from '@hover/tokens-device';
import * as tokens$2 from '@hover/tokens-color';
import _map from 'ramda/src/map';
import * as tokens$3 from '@hover/tokens-motion';
import { _ as _objectSpread2 } from './objectSpread2-b7b195c3.esm.js';
import * as tokens$4 from '@hover/tokens-depth';
import { transparentize } from 'polished';
import * as sizeTokens from '@hover/tokens-size';
import * as tokens$5 from '@hover/tokens-space';
import * as tokens$6 from '@hover/tokens-typography';
var borderWidths = {
  0: tokens.width0,
  400: tokens.width400,
  500: tokens.width500
};
var breakpoints = {
  width100: tokens$1.breakpointWidth100,
  width200: tokens$1.breakpointWidth200,
  width300: tokens$1.breakpointWidth300,
  width400: tokens$1.breakpointWidth400,
  width500: tokens$1.breakpointWidth500,
  desktop: tokens$1.breakpointWidthDesktop,
  mobile: tokens$1.breakpointWidthMobile,
  tablet: tokens$1.breakpointWidthTablet
};
var colors = {
  primary: {
    50: tokens$2.primary50,
    100: tokens$2.primary100,
    200: tokens$2.primary200,
    300: tokens$2.primary300,
    400: tokens$2.primary400,
    500: tokens$2.primary500,
    600: tokens$2.primary600,
    700: tokens$2.primary700,
    800: tokens$2.primary800,
    900: tokens$2.primary900,
    base: tokens$2.primaryBase
  },
  secondary: {
    100: tokens$2.secondary100,
    200: tokens$2.secondary200,
    300: tokens$2.secondary300,
    400: tokens$2.secondary400,
    500: tokens$2.secondary500,
    600: tokens$2.secondary600,
    700: tokens$2.secondary700,
    800: tokens$2.secondary800,
    900: tokens$2.secondary900,
    base: tokens$2.secondaryBase
  },
  neutral: {
    0: tokens$2.neutral0,
    50: tokens$2.neutral50,
    100: tokens$2.neutral100,
    200: tokens$2.neutral200,
    300: tokens$2.neutral300,
    400: tokens$2.neutral400,
    500: tokens$2.neutral500,
    550: tokens$2.neutral550,
    600: tokens$2.neutral600,
    700: tokens$2.neutral700,
    900: tokens$2.neutral900,
    background: tokens$2.neutralBackground,
    backgroundDark: tokens$2.neutralBackgroundDark,
    disabled: tokens$2.neutralDisabled,
    text: tokens$2.neutralText,
    textLight: tokens$2.neutralTextLight
  },
  success: {
    50: tokens$2.success50,
    100: tokens$2.success100,
    200: tokens$2.success200,
    300: tokens$2.success300,
    400: tokens$2.success400,
    500: tokens$2.success500,
    600: tokens$2.success600,
    700: tokens$2.success700,
    800: tokens$2.success800,
    900: tokens$2.success900,
    base: tokens$2.successBase
  },
  warning: {
    50: tokens$2.warning50,
    100: tokens$2.warning100,
    200: tokens$2.warning200,
    300: tokens$2.warning300,
    400: tokens$2.warning400,
    500: tokens$2.warning500,
    600: tokens$2.warning600,
    700: tokens$2.warning700,
    800: tokens$2.warning800,
    900: tokens$2.warning900,
    base: tokens$2.warningBase
  },
  danger: {
    50: tokens$2.danger50,
    100: tokens$2.danger100,
    200: tokens$2.danger200,
    300: tokens$2.danger300,
    400: tokens$2.danger400,
    500: tokens$2.danger500,
    600: tokens$2.danger600,
    700: tokens$2.danger700,
    800: tokens$2.danger800,
    900: tokens$2.danger900,
    base: tokens$2.dangerBase
  },
  brandNavy: {
    100: tokens$2.brandNavy100,
    200: tokens$2.brandNavy200,
    300: tokens$2.brandNavy300,
    400: tokens$2.brandNavy400,
    500: tokens$2.brandNavy500,
    600: tokens$2.brandNavy600,
    700: tokens$2.brandNavy700,
    800: tokens$2.brandNavy800,
    900: tokens$2.brandNavy900
  },
  brandGreen: {
    100: tokens$2.brandGreen100,
    200: tokens$2.brandGreen200,
    300: tokens$2.brandGreen300,
    400: tokens$2.brandGreen400,
    500: tokens$2.brandGreen500,
    600: tokens$2.brandGreen600,
    700: tokens$2.brandGreen700,
    800: tokens$2.brandGreen800,
    900: tokens$2.brandGreen900
  },
  brandBrown: {
    100: tokens$2.brandBrown100,
    200: tokens$2.brandBrown200,
    300: tokens$2.brandBrown300,
    400: tokens$2.brandBrown400,
    500: tokens$2.brandBrown500,
    600: tokens$2.brandBrown600,
    700: tokens$2.brandBrown700,
    800: tokens$2.brandBrown800,
    900: tokens$2.brandBrown900
  },
  brandRed: {
    100: tokens$2.brandRed100,
    200: tokens$2.brandRed200,
    300: tokens$2.brandRed300,
    400: tokens$2.brandRed400,
    500: tokens$2.brandRed500,
    600: tokens$2.brandRed600,
    700: tokens$2.brandRed700,
    800: tokens$2.brandRed800,
    900: tokens$2.brandRed900
  },
  brandTan: {
    100: tokens$2.brandTan100,
    200: tokens$2.brandTan200,
    300: tokens$2.brandTan300,
    400: tokens$2.brandTan400,
    500: tokens$2.brandTan500,
    600: tokens$2.brandTan600,
    700: tokens$2.brandTan700,
    800: tokens$2.brandTan800,
    900: tokens$2.brandTan900
  },
  brandOrange: {
    100: tokens$2.brandOrange100,
    200: tokens$2.brandOrange200,
    300: tokens$2.brandOrange300,
    400: tokens$2.brandOrange400,
    500: tokens$2.brandOrange500,
    600: tokens$2.brandOrange600,
    700: tokens$2.brandOrange700,
    800: tokens$2.brandOrange800,
    900: tokens$2.brandOrange900
  },
  brandYellow: {
    100: tokens$2.brandYellow100,
    200: tokens$2.brandYellow200,
    300: tokens$2.brandYellow300,
    400: tokens$2.brandYellow400,
    500: tokens$2.brandYellow500,
    600: tokens$2.brandYellow600,
    700: tokens$2.brandYellow700,
    800: tokens$2.brandYellow800,
    900: tokens$2.brandYellow900
  },
  brandPurple: {
    100: tokens$2.brandPurple100,
    200: tokens$2.brandPurple200,
    300: tokens$2.brandPurple300,
    400: tokens$2.brandPurple400,
    500: tokens$2.brandPurple500,
    600: tokens$2.brandPurple600,
    700: tokens$2.brandPurple700,
    800: tokens$2.brandPurple800,
    900: tokens$2.brandPurple900
  },
  lightAlpha: {
    50: tokens$2.lightAlpha50,
    100: tokens$2.lightAlpha100,
    200: tokens$2.lightAlpha200,
    300: tokens$2.lightAlpha300,
    400: tokens$2.lightAlpha400,
    500: tokens$2.lightAlpha600,
    600: tokens$2.lightAlpha600,
    700: tokens$2.lightAlpha700,
    800: tokens$2.lightAlpha800,
    900: tokens$2.lightAlpha900
  },
  darkAlpha: {
    50: tokens$2.darkAlpha50,
    100: tokens$2.darkAlpha100,
    200: tokens$2.darkAlpha200,
    300: tokens$2.darkAlpha300,
    400: tokens$2.darkAlpha400,
    500: tokens$2.darkAlpha600,
    600: tokens$2.darkAlpha600,
    700: tokens$2.darkAlpha700,
    800: tokens$2.darkAlpha800,
    900: tokens$2.darkAlpha900
  },
  overlayLight: tokens$2.overlayLight,
  overlayDark: tokens$2.overlayDark
};
var schemes = ['primary', 'secondary', 'neutral', 'success', 'warning', 'danger', 'brandNavy', 'brandGreen', 'brandBrown', 'brandRed', 'brandTan', 'brandOrange', 'brandYellow'];
var productSchemes = ['primary', 'secondary', 'neutral', 'success', 'warning', 'danger'];
var brandSchemes = ['brandNavy', 'brandGreen', 'brandBrown', 'brandRed', 'brandTan', 'brandOrange', 'brandYellow'];

var fromEasingPreset = function fromEasingPreset(_ref) {
  var duration = _ref.duration,
      x1 = _ref.x1,
      y1 = _ref.y1,
      x2 = _ref.x2,
      y2 = _ref.y2;
  return "".concat(duration, " cubic-bezier(").concat(x1, ", ").concat(y1, ", ").concat(x2, ", ").concat(y2, ")");
};

var easingPresets = {
  150: {
    duration: tokens$3.easing150Duration,
    x1: tokens$3.easing150X1,
    y1: tokens$3.easing150Y1,
    x2: tokens$3.easing150X2,
    y2: tokens$3.easing150Y2
  },
  250: {
    duration: tokens$3.easing250Duration,
    x1: tokens$3.easing250X1,
    y1: tokens$3.easing250Y1,
    x2: tokens$3.easing250X2,
    y2: tokens$3.easing250Y2
  }
};
var springPresets = {
  firm: {
    friction: tokens$3.springFirmFriction,
    mass: tokens$3.springFirmMass,
    tension: tokens$3.springFirmTension,
    velocity: tokens$3.springFirmVelocity
  }
};
var framerPresets = {
  firm: {
    type: tokens$3.framerFirmType,
    damping: tokens$3.framerFirmDamping,
    mass: tokens$3.framerFirmMass,
    stiffness: tokens$3.framerFirmStiffness,
    velocity: tokens$3.framerFirmVelocity
  },
  tight: {
    type: tokens$3.framerTightType,
    damping: tokens$3.framerTightDamping,
    mass: tokens$3.framerTightMass,
    stiffness: tokens$3.framerTightStiffness,
    velocity: tokens$3.framerTightVelocity
  }
};

var easings = /*#__PURE__*/_map(fromEasingPreset, easingPresets);

var springs = springPresets;
var framer = framerPresets;
var motion = {
  easings: easings,
  springs: springs,
  framer: framer
};

var fromPreset = function fromPreset(_ref) {
  var borderColor = _ref.borderColor,
      borderStyle = _ref.borderStyle,
      borderWidth = _ref.borderWidth;
  return "".concat(borderWidth, " ").concat(borderStyle, " ").concat(borderColor);
};

var common = {
  borderStyle: 'solid',
  borderWidth: tokens.width400,
  borderRadius: tokens.radius300
};

var danger = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorDanger
});

var disabled = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorDisabled
});

var invalid = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorInvalid
});

var invalidFocus = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorInvalidFocus
});

var neutral = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorNeutral
});

var primary = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorPrimary
});

var focus = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorFocus
});

var focusDanger = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorFocusDanger
});

var focusNeutral = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorFocusNeutral
});

var focusSuccess = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorFocusSuccess
});

var focusWarning = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, common), {}, {
  borderColor: tokens.colorFocusWarning
});

var presets = {
  danger: danger,
  disabled: disabled,
  focus: focus,
  focusDanger: focusDanger,
  focusNeutral: focusNeutral,
  focusSuccess: focusSuccess,
  focusWarning: focusWarning,
  idle: neutral,
  invalid: invalid,
  invalidFocus: invalidFocus,
  neutral: neutral,
  primary: primary
};

var borders = /*#__PURE__*/_map(fromPreset, presets);

var radii = {
  200: tokens.radius200,
  300: tokens.radius300,
  400: tokens.radius400,
  500: tokens.radius500,
  900: tokens.radius900,
  round: tokens.radiusRound
};

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var INSET_SOFTEN_FACTOR = 3;
/**
 * Generates a `box-shadow` CSS property from a shadow preset
 *
 * @example
 * boxShadow('#000', 0.75, '1px', '1px', '3px');
 * // '1px 1px 3px rgba(0, 0, 0, 0.25)'
 *
 * @param color - shadow color
 * @param opacity - opacity to be applied to shadow color
 * @param values - remaining shadow values in the same order as CSS spec
 *
 * @returns `box-shadow` CSS property value
 */

var boxShadow = function boxShadow() {
  for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
    _ref[_key] = arguments[_key];
  }

  var color = _ref[0],
      opacity = _ref[1],
      shadow = _ref.slice(2);

  return shadow.concat(transparentize(1 - opacity, color)).join(' ');
};

var insetBoxShadow = function insetBoxShadow() {
  for (var _len2 = arguments.length, _ref2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    _ref2[_key2] = arguments[_key2];
  }

  var color = _ref2[0],
      opacity = _ref2[1],
      shadow = _ref2.slice(2);

  return "inset ".concat(boxShadow.apply(void 0, [color, opacity / INSET_SOFTEN_FACTOR].concat(_toConsumableArray(shadow))));
};
/**
 * Generates a composite `box-shadow` CSS
 * property from an array of shadow presets
 *
 * @example
 * boxShadow([
 *   ['#000', 0.75, '1px', '1px', '3px'],
 *   ['#333', 0.25, '2px', '2px', '5px']
 * ]);
 *
 * // '1px 1px 3px rgba(0, 0, 0, 0.25), 1px 1px 3px rgba(51, 51, 51, 0.75)'
 *
 * @param shadows shadow presets
 *
 * @returns `box-shadow` CSS property value
 */


var boxShadows = function boxShadows(shadows) {
  var inset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return shadows.map(function (s) {
    return (inset ? insetBoxShadow : boxShadow).apply(void 0, _toConsumableArray(s));
  }).join(',');
};
/**
 * Retrieve a shadow preset from depth tokens
 *
 * @example
 * // Retrieves tokens `distance500Color`, `distance500Opacity`, etc.
 * getShadowPresetFromTokens('500')
 * // ['0px', 0.4, '0px', '2px', '6px', '0px']
 *
 *
 * @param name shadow name (e.g: `'500'` → `'distance500'`)
 * @returns shadow preset
 */


var getShadowPresetFromTokens = function getShadowPresetFromTokens(name) {
  var color = "".concat(name, "Color");
  var opacity = "".concat(name, "Opacity");
  var offsetX = "".concat(name, "OffsetX");
  var offsetY = "".concat(name, "OffsetY");
  var blurRadius = "".concat(name, "BlurRadius");
  var spreadRadius = "".concat(name, "SpreadRadius");
  return [tokens$4[color], tokens$4[opacity], tokens$4[offsetX], tokens$4[offsetY], tokens$4[blurRadius], tokens$4[spreadRadius]];
};
/**
 * Retrieve a CSS `box-shadow` value from depth tokens
 *
 * @example
 * // Retrieves shadow for `distance500`
 * getShadowProperties('500')
 * // ['0px', 0.4, '0px', '2px', '6px', '0px']
 *
 *
 * @param name shadow name (e.g: `'500'` → `'distance500'`)
 * @returns shadow preset
 */


var getBoxShadowFromTokens = function getBoxShadowFromTokens(name) {
  var inset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Array.isArray(name) ? boxShadows(name.map(getShadowPresetFromTokens), inset) : (inset ? insetBoxShadow : boxShadow).apply(void 0, _toConsumableArray(getShadowPresetFromTokens(name)));
};

var shadows = {
  distance100: /*#__PURE__*/getBoxShadowFromTokens(['distance100A', 'distance100B', 'distance100C', 'distance100D']),
  distance200: /*#__PURE__*/getBoxShadowFromTokens(['distance200A', 'distance200B', 'distance200C', 'distance200D', 'distance200E', 'distance200F']),
  distance300: /*#__PURE__*/getBoxShadowFromTokens(['distance300A', 'distance300B', 'distance300C', 'distance300D', 'distance300E']),
  distance400: /*#__PURE__*/getBoxShadowFromTokens(['distance400A', 'distance400B', 'distance400C', 'distance400D', 'distance400E', 'distance400F', 'distance400G', 'distance400H', 'distance400I']),
  inset100: /*#__PURE__*/getBoxShadowFromTokens(['distance100A', 'distance100B', 'distance100C'], true),
  inset200: /*#__PURE__*/getBoxShadowFromTokens(['distance200A', 'distance200B', 'distance200C', 'distance200D', 'distance200E', 'distance200F'], true),
  distance500: /*#__PURE__*/getBoxShadowFromTokens('distance500'),
  distance600: /*#__PURE__*/getBoxShadowFromTokens('distance600'),
  // Rings
  ringPrimary: /*#__PURE__*/getBoxShadowFromTokens('ringPrimary'),
  ringNeutral: /*#__PURE__*/getBoxShadowFromTokens('ringNeutral'),
  // Halos
  haloNeutral: /*#__PURE__*/getBoxShadowFromTokens('haloNeutral'),
  haloPrimary: /*#__PURE__*/getBoxShadowFromTokens('haloPrimary'),
  haloSuccess: /*#__PURE__*/getBoxShadowFromTokens('haloSuccess'),
  haloWarning: /*#__PURE__*/getBoxShadowFromTokens('haloWarning'),
  haloDanger: /*#__PURE__*/getBoxShadowFromTokens('haloDanger'),
  invisibleNeutral: /*#__PURE__*/boxShadow(tokens$4.haloNeutralColor, 0, '0', '0', '0', '0')
};
var sizes = {
  25: sizeTokens.size25,
  50: sizeTokens.size50,
  75: sizeTokens.size75,
  100: sizeTokens.size100,
  200: sizeTokens.size200,
  300: sizeTokens.size300,
  375: sizeTokens.size375,
  400: sizeTokens.size400,
  500: sizeTokens.size500,
  600: sizeTokens.size600,
  700: sizeTokens.size700,
  750: sizeTokens.size750,
  800: sizeTokens.size800,
  850: sizeTokens.size850,
  900: sizeTokens.size900
};
var space = {
  0: tokens$5.size0,
  50: tokens$5.size50,
  100: tokens$5.size100,
  200: tokens$5.size200,
  300: tokens$5.size300,
  400: tokens$5.size400,
  500: tokens$5.size500,
  600: tokens$5.size600,
  700: tokens$5.size700,
  800: tokens$5.size800,
  900: tokens$5.size900,
  1000: tokens$5.size1000,
  1100: tokens$5.size1100
};
var typography = {
  fonts: {
    body: tokens$6.familyBody,
    brand: tokens$6.familyBrand,
    code: tokens$6.familyCode,
    display: tokens$6.familyDisplay
  },
  lineHeights: {
    50: tokens$6.height50,
    100: tokens$6.height100,
    200: tokens$6.height200,
    300: tokens$6.height300,
    400: tokens$6.height400,
    500: tokens$6.height500,
    600: tokens$6.height600,
    700: tokens$6.height700,
    800: tokens$6.height800,
    900: tokens$6.height900,
    1000: tokens$6.height1000
  },
  fontWeights: {
    100: tokens$6.weight100,
    300: tokens$6.weight300,
    400: tokens$6.weight400,
    500: tokens$6.weight500,
    600: tokens$6.weight600,
    700: tokens$6.weight700,
    body: tokens$6.weightBody,
    bodyBold: tokens$6.weightBodyBold,
    bodySemiBold: tokens$6.weightBodySemiBold,
    display: tokens$6.weightDisplay,
    heading: tokens$6.weightHeading,
    headingLight: tokens$6.weightHeadingLight
  },
  fontSizes: {
    50: tokens$6.size50,
    100: tokens$6.size100,
    200: tokens$6.size200,
    300: tokens$6.size300,
    400: tokens$6.size400,
    500: tokens$6.size500,
    600: tokens$6.size600,
    700: tokens$6.size700,
    800: tokens$6.size800,
    900: tokens$6.size900,
    1000: tokens$6.size1000,
    base: tokens$6.sizeBase
  },
  legacy: {
    fonts: {
      body: tokens$6.legacyFamilyBody,
      brand: tokens$6.legacyFamilyBrand,
      display: tokens$6.legacyFamilyDisplay
    },
    fontWeights: {
      body: tokens$6.legacyWeightBody,
      display: tokens$6.legacyWeightDisplay,
      heading: tokens$6.legacyWeightHeading,
      headingLight: tokens$6.legacyWeightHeadingLight
    }
  }
};
export { breakpoints as a, borderWidths as b, colors as c, brandSchemes as d, presets as e, borders as f, shadows as g, sizes as h, space as i, motion as m, productSchemes as p, radii as r, schemes as s, typography as t };